module.exports = __webpack_public_path__ + "img/1552950220.7e80d980.jpg";